var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Logo',{attrs:{"id":"logo"}}),_c('Categorie',{attrs:{"id":"categorie"}}),_c('Message',{staticClass:"fixed-bottom",attrs:{"id":"message"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }